import { useContext } from 'react';
import { UserContext } from '../components/MiniDrawer';

/**
 * Hook per ottenere l'utente corrente
 * Priorità: backendUser > cognitoUser
 */
export const useCurrentUser = () => {
  const context = useContext(UserContext);
  
  if (!context) {
    throw new Error('useCurrentUser must be used within a UserContext.Provider');
  }
  
  const { cognitoUser, backendUser, isAuthenticated, authLoading } = context;
  
  // Restituisce l'utente del backend se disponibile, altrimenti quello di Cognito
  const currentUser = backendUser || cognitoUser;
  
  return {
    user: currentUser,
    cognitoUser,
    backendUser,
    isAuthenticated,
    authLoading,
    // Helper per verificare se l'utente è stato trovato nel backend
    hasBackendUser: !!backendUser,
    // Helper per ottenere l'ID dell'utente (priorità al backend)
    userId: backendUser?.id || cognitoUser?.sub,
    // Helper per ottenere l'email (priorità al backend)
    userEmail: backendUser?.email || cognitoUser?.email,
    // Helper per ottenere il nome (priorità al backend)
    userName: backendUser?.name || backendUser?.username || cognitoUser?.name || cognitoUser?.email
  };
}; 